export default function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
    return classList.concat(arg);
  }, []).filter(function (arg) {
    return typeof arg === 'string';
  }).join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./~/merge-class-names/dist/esm/index.js
// module id = 406
// module chunks = 1